import React from "react";

import jsPDF from "jspdf";

class Module1PDFGenerator extends React.Component {
  genertatePDF(
    pdfInfo_Values,
    pdfInfo_Strengths,
    pdfInfo_FirstAnswer,
    pdfInfo_SecondAnswer,
    pdfInfo_YesNoAnswer,
    pdfInfo_ReflQuestion,
    pdfInfo_ThirdAnswer,
    pdfInfo_FourthAnswer,
    pdfInfo_FifthAnswer
  ) {
    var doc = new jsPDF("p", "pt");
    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    var data = require("./pdfData.json");

    //Page1
    doc.addImage(data[0].page1, "png", 0, 0, width, height);

    //Page2
    doc.addPage();
    doc.addImage(data[1].page2, 0, 0, width, height);

    doc.setFontSize(11);
    doc.setFontType("normal");

    if (pdfInfo_Values.length == 5) {
      var values = require("../ValuesData.json");
      var descriptions = [];
      for (var i = 0; i < 5; i++) {
        for (var j = 0; j < values.length; j++) {
          if (pdfInfo_Values[i] == values[j].name) {
            descriptions.push(values[j].description);
          }
        }
      }
      doc.setFontType("bold");
      doc.text(doc.splitTextToSize(pdfInfo_Values[0], 180), 87, 292);
      doc.text(doc.splitTextToSize(pdfInfo_Values[1], 150), 87, 292 + 102);
      doc.text(doc.splitTextToSize(pdfInfo_Values[2], 150), 87, 292 + 2 * 102);
      doc.text(doc.splitTextToSize(pdfInfo_Values[3], 150), 87, 292 + 3 * 102);
      doc.text(doc.splitTextToSize(pdfInfo_Values[4], 150), 87, 292 + 4 * 102);

      doc.setFontType("normal");

      doc.text(doc.splitTextToSize(descriptions[0], 250), 253, 292);
      doc.text(doc.splitTextToSize(descriptions[1], 250), 253, 292 + 102);
      doc.text(doc.splitTextToSize(descriptions[2], 250), 253, 292 + 2 * 102);
      doc.text(doc.splitTextToSize(descriptions[3], 250), 253, 292 + 3 * 102);
      doc.text(doc.splitTextToSize(descriptions[4], 250), 253, 292 + 4 * 102);
    }

    //Page3
    doc.addPage();
    doc.addImage(data[2].page3, 0, 0, width, height);
    doc.text(doc.splitTextToSize(pdfInfo_FirstAnswer, 470), 71, 183);

    //Page4
    doc.addPage();
    doc.addImage(data[3].page4, 0, 0, width, height);
    doc.text(doc.splitTextToSize(pdfInfo_SecondAnswer, 470), 71, 111);

    //Page5
    doc.addPage();
    doc.addImage(data[4].page5, 0, 0, width, height);

    //Page6
    doc.addPage();
    doc.addImage(data[5].page6, 0, 0, width, height);
    if (pdfInfo_Strengths.length == 5) {
      var strengths = require("../StrengthsData.json");
      var descriptions = [];
      for (var i = 0; i < 5; i++) {
        for (var j = 0; j < strengths.length; j++) {
          if (pdfInfo_Strengths[i] == strengths[j].name) {
            descriptions.push(strengths[j].description);
          }
        }
      }
      doc.setFontType("bold");
      doc.text(doc.splitTextToSize(pdfInfo_Strengths[0], 130), 87, 125);
      doc.text(doc.splitTextToSize(pdfInfo_Strengths[1], 130), 87, 125 + 130);
      doc.text(
        doc.splitTextToSize(pdfInfo_Strengths[2], 130),
        87,
        125 + 2 * 130
      );
      doc.text(
        doc.splitTextToSize(pdfInfo_Strengths[3], 130),
        87,
        125 + 3 * 130
      );
      doc.text(
        doc.splitTextToSize(pdfInfo_Strengths[4], 130),
        87,
        125 + 4 * 130
      );

      doc.setFontType("normal");

      doc.text(doc.splitTextToSize(descriptions[0], 250), 235, 125);
      doc.text(doc.splitTextToSize(descriptions[1], 250), 235, 125 + 130);
      doc.text(doc.splitTextToSize(descriptions[2], 250), 235, 125 + 2 * 130);
      doc.text(doc.splitTextToSize(descriptions[3], 250), 235, 125 + 3 * 130);
      doc.text(doc.splitTextToSize(descriptions[4], 250), 235, 125 + 4 * 130);
    }

    //Page7
    doc.addPage();
    doc.addImage(data[6].page7, 0, 0, width, height);
    doc.text(doc.splitTextToSize(pdfInfo_YesNoAnswer, 470), 71, 165);
    doc.setFontType("italic");
    doc.setFontSize(14);
    doc.text(doc.splitTextToSize(pdfInfo_ReflQuestion, 470), 71, 200);
    doc.setFontType("normal");
    doc.setFontSize(11);
    doc.text(doc.splitTextToSize(pdfInfo_ThirdAnswer, 470), 71, 230);

    //Page8
    doc.addPage();
    doc.addImage(data[7].page8, 0, 0, width, height);

    //Page9
    doc.addPage();
    doc.addImage(data[8].page9, 0, 0, width, height);

    //Page10
    doc.addPage();
    doc.addImage(data[9].page10, 0, 0, width, height);
    doc.text(doc.splitTextToSize(pdfInfo_FourthAnswer, 470), 71, 165);

    //Page11
    doc.addPage();
    doc.addImage(data[10].page11, 0, 0, width, height);
    doc.text(doc.splitTextToSize(pdfInfo_FifthAnswer, 470), 71, 128);

    //Page12
    doc.addPage();
    doc.addImage(data[11].page12, 0, 0, width, height);

    doc.save("I Have No Idea What I Want To Do.pdf");
  }

  render() {
    return <div></div>;
  }
}

export default Module1PDFGenerator;
